import { render, staticRenderFns } from "./Cashes.vue?vue&type=template&id=06d6af66&"
import script from "./Cashes.vue?vue&type=script&lang=js&"
export * from "./Cashes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports